<mat-form-field class="flex-28">
  <mat-label>{{ getLabelText() }}</mat-label>
  <mat-select placeholder="{{ getPlaceHolderText() }}" formControlName="controlSelect">
    @for (option of selectOptions; track option) {
      <mat-option [value]="option.id">
        {{ option.value | translateKey: 'catalogs' }}
      </mat-option>
    }
  </mat-select>
  @if (controlSelect) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="clearProperty($event)">
      <mat-icon>{{ 'labels.buttons.Close' | translate }}</mat-icon>
    </button>
  }
</mat-form-field>
